import { Icon, icons } from '../../../generic';
import type { Repository } from '../../../../types';

import ProjectRowBase from './ProjectRowBase';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './ConnectableProjectRow.module.less';

type ConnectableProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

const ConnectableProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
  onImportRepository,
}: ConnectableProjectRowProps) => {
  const status = (
    <span className={styles.connectionExplainer}>
      <Icon icon={icons.circleInfo} />
      <span>
        Already imported via CLI. Import here to connect to GitHub.
      </span>
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      onImportRepository={onImportRepository}
      status={status}
      rowClassName={styles.row}
    />
  );
};

export default ConnectableProjectRow;
